import { http } from './http_service';

//Get list of email template content with paginate
export function listPage(obj){
  let params = {
      page:obj.page,
      recordsPerPage:obj.recordsPerPage,
      q:obj.q,
      categoryId:obj.categoryId,
      selectedStatus:obj.selectedStatus,
      sort_direction:obj.sort_direction,
      sort_field:obj.sort_field
  }
  return http().get(`/email-template/list-page`, {
      params:params
  });
}

//Get Single
export function single(id){
  return http().get(`/email-template/single/${id}`);
}

//Add one
export function add(data){
  return http().post('/email-template/add', data)
}

//Update
export function update(id, data){
  return http().post(`/email-template/update/${id}`, data)
}

//Email Template List Dropdown
export function dropdownList(obj){
  let params = {
    categoryId:obj.categoryId,
  }
  return http().get(`/email-template/dropdown/list`, {params:params});
}




